import { createSlice } from "@reduxjs/toolkit";
import { ALL_ICONS } from "../../data/icons";
const topicsSliceOptions = {
  name: 'topics',
  initialState: {
    topics: {
      // '111': {
      //     id: '111',
      //     name:'topic 1',
      //     icon :"Book",
      //     quizIds: []
      // },
      // '222': {
      //     id: '222',
      //     name:'Book',
      //     icon : ALL_ICONS[0].url,
      //     quizIds: []
      // }


    }
  },
  reducers: {
    addTopic: (state, action) => {
      const { id, name, icon } = action.payload;
      state.topics[id] = {
        id: id,
        name: name,
        icon,
        quizIds: []
      }
    },
    addQuizForTopicId: (state, action) => {
      const { topicId, quizId } = action.payload;
      if (state.topics[topicId]) {
        state.topics[topicId].quizIds.push(quizId);
      } else {
        console.error(`Topic with ID ${topicId} not found.`);
      }

    }
  }
};

export const topicsSlice = createSlice(topicsSliceOptions);
export const selectTopics = (state) => state.topics.topics;
export const { addTopic, addQuizForTopicId } = topicsSlice.actions;
export default topicsSlice.reducer;